/**
 * Download base64-encoded content as a file.
 * Creates a temporary blob URL, triggers the download, and revokes it on the next tick
 * (immediate revocation can cancel downloads in some browsers).
 */
export function downloadBase64File(content: string, mimeType: string, fileName: string): void {
  let decoded: string;
  try {
    decoded = atob(content);
  } catch {
    throw new Error(`Invalid base64 content for file "${fileName}"`);
  }
  const byteArray = Uint8Array.from(decoded, (c) => c.charCodeAt(0));
  const blob = new Blob([byteArray], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}
